import chat from "./modules/chat"
export default {
    modules: {
        chat,
    }
}
